<template>
  <div class="material-check-page frame-page access-log-page">
    <div class="page-intro">
      <p>记录访问者 IP 与打开的页面，仅系统管理员可查看。日志保留约 90 天。</p>
    </div>

    <section class="panel">
      <div class="panel-title panel-title-actions">
        <div class="panel-title-left">
          <span class="step">1</span>
          <span>访问记录</span>
          <span v-if="total" class="tag tag-done">{{ total }} 条</span>
          <span v-else class="tag tag-muted">暂无</span>
        </div>
        <div class="panel-title-right">
          <Input
            v-model="keyword"
            placeholder="搜索 IP / 用户 / 页面 / 路径"
            style="width: 240px"
            @keyup.enter="search"
          />
          <Button size="s" color="primary" @click="search">查询</Button>
          <Button size="s" @click="resetSearch">重置</Button>
        </div>
      </div>

      <div v-if="loading" class="empty-hint">加载中…</div>
      <div v-else-if="!items.length" class="empty-hint">暂无访问记录。</div>
      <div v-else class="table-wrap">
        <table class="data-table">
          <thead>
            <tr>
              <th>访问时间</th>
              <th>IP</th>
              <th>用户</th>
              <th>页面</th>
              <th>路径</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in items" :key="item.id">
              <td>{{ item.createdAt }}</td>
              <td>{{ item.ip || '—' }}</td>
              <td>{{ item.username || '—' }}</td>
              <td>{{ item.page || '—' }}</td>
              <td>{{ item.path || '—' }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="total > pageSize" class="pager">
        <Button size="s" :disabled="page <= 1" @click="changePage(page - 1)">上一页</Button>
        <span>{{ page }} / {{ pageCount }} · 共 {{ total }} 条</span>
        <Button size="s" :disabled="page >= pageCount" @click="changePage(page + 1)">下一页</Button>
      </div>
    </section>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { message } from 'heyui';
import Request from '@common/request';

const loading = ref(false);
const keyword = ref('');
const items = ref([]);
const page = ref(1);
const pageSize = ref(20);
const total = ref(0);
const pageCount = computed(() => Math.max(1, Math.ceil(total.value / pageSize.value)));

async function loadList() {
  loading.value = true;
  try {
    const resp = await Request.Access.list({
      keyword: keyword.value.trim(),
      page: page.value,
      pageSize: pageSize.value,
    });
    if (!resp.ok) {
      message.error(resp._msg || '加载访问日志失败');
      return;
    }
    const body = resp.body || {};
    items.value = body.items || [];
    total.value = body.total || 0;
    page.value = body.page || page.value;
  } finally {
    loading.value = false;
  }
}

function search() {
  page.value = 1;
  loadList();
}

function resetSearch() {
  keyword.value = '';
  page.value = 1;
  loadList();
}

function changePage(next) {
  page.value = next;
  loadList();
}

onMounted(loadList);
</script>

<style lang="less" scoped>
@import '@/views/material-check/material-check.less';

.empty-hint {
  padding: 28px 0;
  text-align: center;
  color: @app-muted;
  font-size: 13px;
}

.table-wrap {
  overflow-x: auto;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;

  th,
  td {
    padding: 9px 10px;
    text-align: left;
    border-bottom: 1px solid #eef1f5;
    white-space: nowrap;
  }

  th {
    color: @app-muted;
    font-weight: 500;
  }

  td {
    color: @app-text;
  }
}

.pager {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
  font-size: 13px;
  color: @app-muted;
}
</style>
